export const getters = {
    systemCustomreleases: state => state.customreleases,
    Customrelease: state => state.systemCustomrelease
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/customreleases/getters.js